window.Shopify.loadFeatures([
  {
    name: 'consent-tracking-api',
    version: '0.1',
  },
]);

window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

const setDefaultConsentValues = () => {
  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied'
  });
}

window.OptanonWrapper = () => {
  //This ensures the OnConsentChanged event listener is attached only after OneTrust is loaded.
  //This is important because the OneTrust object may not be available immediately.
  if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
    window.OneTrust.OnConsentChanged(function () {
      const analyticsConsent = OnetrustActiveGroups.includes('C0002') ? true : false;
      const marketingConsent = OnetrustActiveGroups.includes('C0003') ? true : false;
      const preferencesConsent = OnetrustActiveGroups.includes('C0004') ? true : false;
      const personalizationConsent = OnetrustActiveGroups.includes('C0005') ? true : false;
  
      gtag('consent', 'update', {
        'analytics_storage': analyticsConsent ? 'granted' : 'denied',
        'ad_storage': marketingConsent ? 'granted' : 'denied',
        'functionality_storage': preferencesConsent ? 'granted' : 'denied',
        'personalization_storage': personalizationConsent ? 'granted' : 'denied',
        'security_storage': preferencesConsent ? 'granted' : 'denied',
        'ad_user_data': marketingConsent ? 'granted' : 'denied',
        'ad_personalization': marketingConsent ? 'granted' : 'denied'
      })
  
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: analyticsConsent,
        marketing: marketingConsent,
        preferences: preferencesConsent
      });
    });
  }
}

const attachOneTrust = () => {
  if (window.troveGlobal.oneTrustTargetLink) {
    const link = document.querySelector(window.troveGlobal.oneTrustTargetLink);

    if (link) {
      link.setAttribute('href', '#showPrivacyCenter');
      link.setAttribute('class', link.getAttribute('class') + ' ot-sdk-show-settings');
      link.setAttribute('id', 'ot-sdk-btn');

      const script = document.createElement('script');
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.defer = 'defer';
      script.setAttribute('data-domain-script', window.troveGlobal.oneTrustDataDomainCode);
      script['data-document-language'] = 'true';
      document.head.appendChild(script);
    }
  }
};

// Set default consent for analytics and ads complying with EU GDPR
//These can be updated to be as restrictive as needed
setDefaultConsentValues();
attachOneTrust();
